/* global I18n */
import React, { useState, useEffect } from 'react'

import post from 'lib/utils/post'
import Toggle from 'lib/forms/toggle'
import Modal from 'react-responsive-modal'

import PropTypes from 'prop-types'

import UsedStrings from './used-strings'
import { usedStrings } from './logic'

const isTranslatorAndWindowDefined = () => {
  if (typeof window === 'undefined') {
    return false
  }
  const body = window.document.getElementsByTagName('body')[0]
  return body && body.dataset.isTranslator === 'true'
}

const TranslateToggle = ({ update }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [missingKeys, setMissingKeys] = useState({})
  const [i18nDevMode, setI18nDevMode] = useState((typeof window !== 'undefined' && window.i18nDevMode) || false)

  const usedStringsLength = Object.keys(usedStrings).length

  useEffect(() => {
    if (typeof window !== 'undefined' && i18nDevMode && usedStringsLength > 0) {
      ;(async setDetails => {
        let processResponse = true
        try {
          const response = await post('/utils/find_missing_translations', {
            keys: Object.keys(usedStrings),
            locale: I18n.locale
          })

          if (processResponse) {
            setMissingKeys(response.missing_keys)
            window.__missingKeys = response.missing_keys
            update()
          }

          setDetails(response.details)
        } catch (error) {
          console.error('Error find missing translations:', error)
        }

        return () => {
          processResponse = false
        }
      })()
    }
  }, [i18nDevMode, update, usedStringsLength])

  const toggleAndUpdate = () => {
    if (typeof window !== 'undefined') {
      window.i18nDevMode = !window.i18nDevMode
      setI18nDevMode(window.i18nDevMode)
      update()
    }
  }

  if (!isTranslatorAndWindowDefined()) {
    return null
  }

  return (
    <div className='i18n-toggle'>
      <Toggle checked={window.i18nDevMode} onClick={toggleAndUpdate} />

      {typeof window !== 'undefined' && window.i18nDevMode ? (
        <span className='i18n-toggle-label' onClick={() => setModalOpen(true)}>
          Show All Used Translations
        </span>
      ) : null}
      <Modal center open={modalOpen} onClose={() => setModalOpen(false)}>
        <div className='i18n-modal'>
          {modalOpen ? (
            <UsedStrings toggleAndUpdate={toggleAndUpdate} usedStrings={usedStrings} missingKeys={missingKeys} />
          ) : null}
        </div>
      </Modal>
    </div>
  )
}

TranslateToggle.propTypes = {
  update: PropTypes.func
}

export default TranslateToggle
